import { setQueriesDataFromKey } from '@pba/react-query';
import type { MessageViewDataObject } from '#models/services';
import { useQueryClient } from '#react-query';
import { type MessagesInfiniteQueryData, getMessagesInfiniteQueryKey } from '../use-get-messages';

export const useAddChatroomMessageToCache = () => {
  const queryClient = useQueryClient();

  return ({ chatroomId, message }: { chatroomId: string; message: MessageViewDataObject }) => {
    setQueriesDataFromKey<MessagesInfiniteQueryData>(
      queryClient,
      getMessagesInfiniteQueryKey({ filter: { chatroomId } }),
      (data) => {
        if (!data) {
          return {
            pageParams: [],
            pages: [[message]],
          };
        }

        return {
          pageParams: data.pageParams,
          pages: [[message, ...(data.pages[0] ?? [])], ...data.pages.slice(1)],
        };
      },
    );
  };
};
